module.exports = __webpack_public_path__ + "img/wild_gold_2_a.684aeb41.png";